import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "@/lib/i18n";
import { AnnouncementProvider } from "@/lib/announcement";
import { AdminAuthProvider, useAdminAuth } from "@/lib/adminAuth";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import ProductDetail from "@/pages/ProductDetail";
import Fenetres from "@/pages/Fenetres";
import PortesGarage from "@/pages/PortesGarage";
import Clotures from "@/pages/Clotures";
import Accessoires from "@/pages/Accessoires";
import RealisationsPage from "@/pages/RealisationsPage";
import Primes from "@/pages/Primes";
import APropos from "@/pages/APropos";
import RendezVous from "@/pages/RendezVous";
import Devis from "@/pages/Devis";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

const RequireAdmin = ({ children }) => {
  const { status } = useAdminAuth();
  if (status === "checking") {
    return <div className="bg-ink min-h-screen flex items-center justify-center text-white/40 text-sm">Chargement…</div>;
  }
  if (status === "anon") return <Navigate to="/admin/login" replace />;
  return children;
};

const RedirectIfAuthed = ({ children }) => {
  const { status } = useAdminAuth();
  if (status === "authed") return <Navigate to="/admin" replace />;
  return children;
};

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          {/* Admin (portable, single-admin JWT) */}
          <Route
            path="/admin/login"
            element={
              <AdminAuthProvider>
                <RedirectIfAuthed>
                  <AdminLogin />
                </RedirectIfAuthed>
              </AdminAuthProvider>
            }
          />
          <Route
            path="/admin"
            element={
              <AdminAuthProvider>
                <RequireAdmin>
                  <Admin />
                </RequireAdmin>
              </AdminAuthProvider>
            }
          />

          {/* Public site */}
          <Route
            element={
              <AnnouncementProvider>
                <Layout />
              </AnnouncementProvider>
            }
          >
            <Route path="/" element={<Home />} />
            <Route path="/produits/fenetres" element={<Fenetres />} />
            <Route path="/produits/portes-de-garage" element={<PortesGarage />} />
            <Route path="/produits/clotures" element={<Clotures />} />
            <Route path="/produits/accessoires" element={<Accessoires />} />
            <Route path="/produits/:slug" element={<ProductDetail />} />
            <Route path="/realisations" element={<RealisationsPage />} />
            <Route path="/primes" element={<Primes />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/rendez-vous" element={<RendezVous />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-de-confidentialite" element={<Confidentialite />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
